import dayjs from 'utils/dayjs'

export default function date(date, format = 'MMM D, YYYY', utc = true) {
  if (utc) {
    return date ? dayjs(date).utc().format(format) : '–'
  } else {
    return date ? dayjs(date).format(format) : '–'
  }
}
